// import React from "react";
// import "./About.css"; // Make sure this file exists
// // import member1 from "../assets/member1.png";
// // import member2 from "../assets/member2.png";
// // import member3 from "../assets/member3.png";

// const About = () => {
//   return (
//     <div className="about-container">
//       <section className="about-section">
//         <h1>👋 About Us</h1>
//         <p>
//           Welcome to <strong>ProMaster Consulting</strong>, your go-to partner for smart digital transformation.
//         </p>
//         <ul>
//           <li>💻 <strong>Digital Marketing:</strong> SEO, campaigns, ads & audience growth.</li>
//           <li>🔐 <strong>Security Consulting:</strong> Cybersecurity audits, compliance, and data protection.</li>
//           <li>📊 <strong>Data Mining:</strong> Uncover insights and trends from complex datasets.</li>
//         </ul>
//         <p className="mission">
//           Our mission is to empower your business with secure, smart, and scalable solutions 🚀
//         </p>
//       </section>

//       <section className="team-section">
//         <h2>Managment</h2>
//         <p className="team-subtitle">Experts who make success happen.</p>

//         <div className="team-cards">
//           <div className="team-card">
//             {/* <img src={member1} alt="Ankita Sharma" /> */}
//             <div className="card-info">
//               <h3>Shri Vir Bahadur Singh</h3>
//               <p>A disciplined and purpose-driven retired IPS officer, committed to public service and national integrity. With strong leadership skills, resilience, and the ability to make quick decisions, he has dedicated his career to crime prevention, community policing, women’s and child safety, and modernizing police administration. Ready to continue contributing toward building a secure and equitable society through civil services.</p>
//             </div>
//           </div>

//           <div className="team-card">
//             {/* <img src={member2} alt="Rohit Mehta" /> */}
//             <div className="card-info">
//               <span className="member-num"></span>
//               <h3>Smt. Priyanshu Amar</h3>
//               <p>A dynamic and empathetic MBA-HR student passionate about talent management, employee relations, and organizational development. Known for strong communication and problem-solving skills, with the ability to thrive in diverse teams. Focused on aligning people strategies with business goals and seeking opportunities in recruitment, L\&D, performance management, and strategic HR planning.</p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default About;


import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-container">
      {/* <section className="about-section">
        <h1>👋 About Us</h1>
        <p>
          Welcome to <strong>ProMaster Consulting</strong>, your trusted partner in crafting secure, data-driven, and high-impact digital solutions.
        </p>
        <p>
          At ProMaster, we blend intelligence with innovation to support your business transformation journey. Whether you're looking to expand your digital footprint, protect your physical infrastructure, or extract valuable insights from data — we’ve got you covered.
        </p>
        <ul>
          <li>💻 <strong>Digital Marketing:</strong> ROI-focused strategies including SEO, ad campaigns, lead generation, and audience analytics.</li>
          <li>🛡️ <strong>Security Consulting:</strong> Led by a decorated retired IPS officer, we specialize in physical security planning, threat assessments, VIP protection, corporate surveillance, and crisis management for organizations, events, and high-value assets.</li>
          <li>📊 <strong>Data Mining:</strong> Advanced data modeling to uncover trends, patterns, and actionable insights that support strategic decisions.</li>
        </ul>
        <p className="mission">
          <em>Our mission is to empower your business with secure, smart, and scalable solutions 🚀</em>
        </p>
      </section> */}

      {/* <section className="about-section">
  <h1>About Us</h1>
  <p>
    Welcome to <strong>ProMaster Consulting</strong>, your trusted partner in delivering secure, data-driven, and high-impact business solutions. At ProMaster, we integrate intelligence with innovation to guide your organization's transformation journey. Our comprehensive offerings span three core areas: Digital Marketing, Security Consulting, and Data Mining. We provide ROI-focused digital marketing strategies, including SEO, lead generation, audience analytics, and performance-driven ad campaigns to strengthen your brand’s online presence. In the domain of Security Consulting, our services are led by a highly experienced retired IPS officer, focusing on physical security strategy, infrastructure protection, threat assessments, VIP and event security, corporate surveillance, and crisis management. Additionally, our Data Mining services deliver deep analytical insights through advanced modeling techniques, helping businesses make informed and strategic decisions. With a commitment to excellence, ProMaster empowers businesses to operate with confidence, security, and smart scalability in an ever-evolving environment.
  </p>
</section> */}

<section className="about-banner">
  <h1>ABOUT US</h1>
</section>

<section className="about-section">
  <p>
    Welcome to <strong>ProMaster Consulting</strong>, your trusted partner in delivering secure, data-driven, and high-impact business solutions. At ProMaster, we integrate intelligence with innovation to guide your organization's transformation journey. Our comprehensive offerings span three core areas: Digital Marketing, Security Consulting, and Data Mining. We provide ROI-focused digital marketing strategies, including SEO, lead generation, audience analytics, and performance-driven ad campaigns to strengthen your brand’s online presence. In the domain of Security Consulting, our services are led by a highly experienced retired IPS officer, focusing on physical security strategy, infrastructure protection, threat assessments, VIP and event security, corporate surveillance, and crisis management. Additionally, our Data Mining services deliver deep analytical insights through advanced modeling techniques, helping businesses make informed and strategic decisions. With a commitment to excellence, ProMaster empowers businesses to operate with confidence, security, and smart scalability in an ever-evolving environment.
  </p>
</section>

    <section className="services-section">
  <h2>What we do</h2>

  {/* Data Mining */}
  <div className="service-item">
    <div className="service-text">
      <h3>📊 Data Mining</h3>
      <p>
        Our Data Mining service focuses on extracting meaningful patterns, trends, and correlations from complex datasets. Using machine learning, statistical algorithms, and custom data models, we help businesses unlock hidden insights that lead to smarter decision-making. Whether it's customer behavior, financial forecasting, or market segmentation, our solutions turn raw data into valuable business assets.
      </p>
      <p>
        We support industries like banking, retail, logistics, and more — delivering custom dashboards, predictive analytics, and strategic data interpretations that elevate operational efficiency and performance.
      </p>
    </div>
  </div>

  {/* Digital Marketing */}
  <div className="service-item reverse">
    <div className="service-text">
      <h3>💻 Digital Marketing</h3>
      <p>
        Our Digital Marketing services are designed to help you achieve measurable growth through targeted campaigns. We specialize in SEO (Search Engine Optimization), paid ads (Google/Facebook), lead generation funnels, email marketing, and audience analytics. Every strategy is tailored to your brand, industry, and customer behavior to maximize ROI.
      </p>
      <p>
        From boosting your search engine rankings to crafting conversion-optimized landing pages, we handle the entire digital ecosystem to ensure your message reaches the right audience, at the right time, with the right impact.
      </p>
    </div>
  </div>

  {/* Security Consulting */}
  <div className="service-item">
    <div className="service-text">
      <h3>🛡️ Security Consulting</h3>
      <p>
        Our Security Consulting division is led by a retired IPS officer with decades of experience in law enforcement and intelligence operations. We provide strategic planning for physical security, threat assessments, VIP and event security, surveillance setup, and crisis response.
      </p>
      <p>
        Whether it’s corporate buildings, government institutions, or high-profile events, we craft customized security frameworks that include SOPs, emergency protocols, access control systems, and risk mitigation strategies. We combine on-ground expertise with modern surveillance technology to keep your assets, people, and data safe.
      </p>
    </div>
  </div>
</section>




      <section className="team-section">
        <h2>👥 Management</h2>
        <p className="team-subtitle">A diverse team of visionaries committed to impact and excellence.</p>

        <div className="team-cards">
          <div className="team-card">
            <div className="card-info">
              <h3>Shri Vir Bahadur Singh</h3>
              <p>
                A disciplined and purpose-driven <strong>retired IPS officer</strong> with decades of experience in law enforcement, public safety, and crisis leadership. He brings deep expertise in physical security, intelligence operations, and community engagement. His commitment to integrity, justice, and national service continues as he now leads ProMaster's Security Consulting division.
              </p>
            </div>
          </div>

          <div className="team-card">
            <div className="card-info">
              <h3>Smt. Priyanshu Amar</h3>
              <p>
                An aspiring HR professional and MBA student with a passion for empowering teams, improving workplace culture, and driving organizational growth. With her focus on talent development, recruitment, and strategic planning, she ensures the human element at ProMaster thrives alongside technology and innovation.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
